import {createStyles} from '@material-ui/core';
import {blackColor, defaultFont} from '../../styles/style';

export const style = createStyles({
  modal: {
    paddingBottom: '8px',
    overflow: 'visible',
  },
  modal__header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'end',
    padding: '0 24px',
  },
  header__title: {
    ...defaultFont,
    fontSize: '20px',
    marginBottom: 0,
  },
  header__categories: {
    ...defaultFont,
    fontSize: '14px',
  },
  modal__checkboxesGroup: {
    color: blackColor,
    display: 'flex',
    gap: '8px',
    flexDirection: 'row',
  },
  modal__suggestCategory: {
    maxWidth: '200px',
    marginTop: '8px',
  },
  modal__actions: {
    justifyContent: 'space-around',
  },
  modal__label: {
    ...defaultFont,
    fontSize: '14px',
  },
});
